<template>
  <section class="preview-body-form">
    <form novalidate @submit.prevent="editar">
      <mdb-input
        label="Nombre de cuenta"
        class="mb-3 mt-0"
        v-model="name"
        required
        invalidFeedback="Coloca un nombre"
      ></mdb-input>
      <mdb-input
        label="App id"
        class="mb-3 mt-0"
        v-model="app_id"
        required
        invalidFeedback="Coloca un app id"
      ></mdb-input>
      <mdb-input
        label="Facebook user id"
        class="mb-3 mt-0"
        v-model="facebook_user_id"
        required
        invalidFeedback="Coloca un facebook user id"
      ></mdb-input>
      <mdb-input
        label="Facebook Business id"
        class="mb-3 mt-0"
        v-model="facebook_business_id"
        required
        invalidFeedback="Coloca un facebook business id"
      ></mdb-input>
      <mdb-input
        label="App Secret"
        class="mb-3 mt-0"
        v-model="app_secret"
        required
        invalidFeedback="Coloca una App secret"
      ></mdb-input>
      <mdb-input
        label="Access token"
        type="textarea"
        class="mb-3 mt-0"
        v-model="access_token"
        :rows="2"
        required
        invalidFeedback="Coloca un Accsess token"
      ></mdb-input>
      <div class="text-center">
        <mdb-btn type="submit" color="primary" :disabled="isLoading">
          <span v-if="!isLoading">Editar</span>
          <semipolar-spinner :animation-duration="2000" :size="30" color="#ffffff" v-if="isLoading"></semipolar-spinner>
        </mdb-btn>
      </div>
    </form>
  </section>
</template>

<script>
import { mdbInput, mdbBtn } from "mdbvue";
import { SemipolarSpinner } from "epic-spinners";
import store from "../../store";
export default {
  name: "modal-2",
  components: {
    mdbInput,
    mdbBtn,
    SemipolarSpinner
  },
  props: {
    onClick: Function,
    account: Object
  },
  data: () => {
    return {
      isLoading: false,
      name: "",
      app_id: "",
      facebook_user_id: "",
      facebook_business_id: "",
      app_secret: "",
      access_token: "",
      id: ""
    };
  },
  mounted() {
    this.name = this.account.name;
    this.app_id = this.account.app_id;
    this.facebook_user_id = this.account.facebook_user_id;
    this.facebook_business_id = this.account.facebook_business_id;
    this.app_secret = this.account.app_secret;
    this.access_token = this.account.access_token;
    this.id = this.account.id;
  },
  methods: {
    editar(event) {
      event.target.classList.add("was-validated");
      var {
        name,
        app_id,
        app_secret,
        facebook_user_id,
        facebook_business_id,
        access_token,
        id
      } = this;
      this.isLoading = true;
      if (
        name == "" ||
        app_id == "" ||
        app_secret == "" ||
        facebook_user_id == "" ||
        facebook_business_id == "" ||
        access_token == ""
      ) {
        this.isLoading = false;
      } else {
        var account = {
          name,
          app_id,
          app_secret,
          facebook_user_id,
          facebook_business_id,
          access_token,
          id
        };
        store.dispatch("editBusinessAccount", account).then(() => {
          this.name = "";
          this.app_id = "";
          this.facebook_user_id = "";
          this.facebook_business_id = "";
          this.app_secret = "";
          this.access_token = "";
          this.onClick("business");
          this.isLoading = false;
        });
      }
    }
  }
};
</script>

<style scoped>
.preview-body-form {
  position: relative;
  top: 10px;
}
</style>